import React from 'react';
import { useNavigate } from 'react-router-dom';
import heroBg from '../assets/premium-hero-bg.png';

import { trackEvent } from "../lib/analytics";

const Hero = () => {
  const navigate = useNavigate();

  function handleBookNow() {
    trackEvent("book_now_click", {
      location: "hero_section"
    });
    navigate('/book');
  }

  return (
    <section id="home" className="hero">
      <img src={heroBg} alt="Premium home spa background" className="hero-image-bg" />
      <div className="hero-content">
        <h1>Glamour Delivered to You</h1>
        <p className="hero-subtitle">
          Command your beauty. Glaminant makes it effortless.
        </p>
        <button className="btn btn-primary" onClick={handleBookNow}>Experience Now</button>
      </div>
    </section>
  );
};

export default Hero;
